import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getSpendByLocationCsv } from 'api/pulse/spendByLocation'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useSpendByLocationDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_spend_by_location', {
        filters: query,
      })
      const data = await getSpendByLocationCsv(query)
      fileDownload(data, 'spend_by_location.csv')
    },
  })
}
